"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TileHighlightOnScroll = /*#__PURE__*/function () {
  function TileHighlightOnScroll(container, isSecond, fullWidth) {
    var _this = this;
    _classCallCheck(this, TileHighlightOnScroll);
    this.OPACITY_RATIO = 0.01;
    this.window = $(window);
    this.isSecond = isSecond;
    this.fullWidth = fullWidth;
    this.container = container;
    this.platform = new Platform();
    this.rolloverLayer = $('.rollover', this.container);
    this.containerHeight = null;
    this.tileOffsetTop = null;
    this.windowCenter = null;
    this.initValues();
    this.window.resize(function () {
      _this.initValues();
      _this.highlightTile();
    });
    this.highlightTile();
    this.window.scroll(function () {
      _this.highlightTile();
    });
  }
  return _createClass(TileHighlightOnScroll, [{
    key: "initValues",
    value: function initValues() {
      this.containerHeight = this.container.height();
      this.tileOffsetTop = this.rolloverLayer.offset().top;
      this.windowCenter = Math.round(this.window.innerHeight() * 0.65);
    }
  }, {
    key: "highlightTile",
    value: function highlightTile() {
      var windowScrollTop = this.window.scrollTop();
      if (this.platform.isPhone()) {
        if (windowScrollTop + this.windowCenter >= this.tileOffsetTop && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight) {
          var setOpacity = Math.min((windowScrollTop + this.windowCenter - this.tileOffsetTop) * this.OPACITY_RATIO, 0.4);
          this.rolloverLayer.css({
            opacity: setOpacity
          });
        } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight) {
          var _setOpacity = Math.max(0.4 + (this.tileOffsetTop + this.containerHeight - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
          this.rolloverLayer.css({
            opacity: _setOpacity
          });
        } else {
          this.rolloverLayer.css({
            opacity: 0
          });
        }
      } else {
        if (this.fullWidth) {
          if (windowScrollTop + this.windowCenter >= this.tileOffsetTop && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight) {
            var _setOpacity2 = Math.min((windowScrollTop + this.windowCenter - this.tileOffsetTop) * this.OPACITY_RATIO, 1);
            this.rolloverLayer.css({
              opacity: _setOpacity2
            });
          } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight) {
            var _setOpacity3 = Math.max(1 + (this.tileOffsetTop + this.containerHeight - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
            this.rolloverLayer.css({
              opacity: _setOpacity3
            });
          } else {
            this.rolloverLayer.css({
              opacity: 0
            });
          }
        } else {
          if (this.isSecond) {
            if (windowScrollTop + this.windowCenter >= this.tileOffsetTop + this.containerHeight * 0.5 && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight) {
              var _setOpacity4 = Math.min((windowScrollTop + this.windowCenter - (this.tileOffsetTop + this.containerHeight * 0.5)) * this.OPACITY_RATIO, 1);
              this.rolloverLayer.css({
                opacity: _setOpacity4
              });
            } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight) {
              var _setOpacity5 = Math.max(1 + (this.tileOffsetTop + this.containerHeight - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
              this.rolloverLayer.css({
                opacity: _setOpacity5
              });
            } else {
              this.rolloverLayer.css({
                opacity: 0
              });
            }
          } else {
            if (windowScrollTop + this.windowCenter >= this.tileOffsetTop && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight * 0.5) {
              var _setOpacity6 = Math.min((windowScrollTop + this.windowCenter - this.tileOffsetTop) * this.OPACITY_RATIO, 1);
              this.rolloverLayer.css({
                opacity: _setOpacity6
              });
            } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight * 0.5) {
              var _setOpacity7 = Math.max(1 + (this.tileOffsetTop + this.containerHeight * 0.5 - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
              this.rolloverLayer.css({
                opacity: _setOpacity7
              });
            } else {
              this.rolloverLayer.css({
                opacity: 0
              });
            }
          }
        }
      }
    }
  }]);
}();